export const ColorCodes = [
    "589500",
    "9ECC3B",
    "FF0000",
    "FF6800",
    "FFD533",
    "00E5FF",
    "3399FF",
    "984AF1",
    "F7F7F7",
    "808080",
    "000000",
    "996633",
    "00FFCC",
    "F704FF",
]

export const styleData = [
    {
        "order": 1,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Default Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Default.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 1,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg",
                "defaultColor": "#9ECC3B",
                "name": "Default",
                "enabled": true,
                "id": 1
            }
        ],
        "name": "Recent",
        "enabled": true,
        "id": 1
    },
    {
        "order": 2,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "ATV",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/ATV.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/ATV.svg",
                "defaultColor": "#9ECC3B",
                "name": "ATV",
                "enabled": true,
                "id": 11
            },
            {
                "description": "Bike",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bike.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bike.svg",
                "defaultColor": "#9ECC3B",
                "name": "Bike",
                "enabled": true,
                "id": 44
            },
            {
                "description": "Boat",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Boat.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Boat.svg",
                "defaultColor": "#9ECC3B",
                "name": "Boat",
                "enabled": true,
                "id": 56
            },
            {
                "description": "Car",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/car.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Car.svg",
                "defaultColor": "#9ECC3B",
                "name": "Car",
                "enabled": true,
                "id": 57
            },
            {
                "description": "Horse",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Horse.png",
                "order": 2,
                "created": "2018-10-22T20:08:46",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Horse.svg",
                "defaultColor": "#9ECC3B",
                "name": "Horse",
                "enabled": true,
                "id": 84
            },
            {
                "description": "Kayak",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/kayak.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Kayak.svg",
                "defaultColor": "#9ECC3B",
                "name": "Kayak",
                "enabled": true,
                "id": 58
            },
            {
                "description": "Motorcycle",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Motorcycle.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dirt%20Bike.svg",
                "defaultColor": "#9ECC3B",
                "name": "Motorcycle",
                "enabled": true,
                "id": 59
            },
            {
                "description": "Snowmobile",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Snowmobile.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Snowmobile.svg",
                "defaultColor": "#9ECC3B",
                "name": "Snowmobile",
                "enabled": true,
                "id": 60
            },
            {
                "description": "Truck",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Truck.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 2,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Truck.svg",
                "defaultColor": "#9ECC3B",
                "name": "Truck",
                "enabled": true,
                "id": 61
            }
        ],
        "name": "Transportation",
        "enabled": true,
        "id": 2
    },
    {
        "order": 3,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Cabin",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cabin.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cabin.svg",
                "defaultColor": "#9ECC3B",
                "name": "Cabin",
                "enabled": true,
                "id": 62
            },
            {
                "description": "Cave",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cave.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cave.svg",
                "defaultColor": "#9ECC3B",
                "name": "Cave",
                "enabled": true,
                "id": 46
            },
            {
                "description": "Home",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Home.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Home.svg",
                "defaultColor": "#9ECC3B",
                "name": "Home",
                "enabled": true,
                "id": 63
            },
            {
                "description": "Lodge",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Shelter.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cabin.svg",
                "defaultColor": "589500",
                "name": "Lodge",
                "enabled": true,
                "id": 50
            },
            {
                "description": "RV",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/RV.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/RV.svg",
                "defaultColor": "#9ECC3B",
                "name": "RV",
                "enabled": true,
                "id": 65
            },
            {
                "description": "Tent",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Camp.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 3,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Tent.svg",
                "defaultColor": "#9ECC3B",
                "name": "Tent",
                "enabled": true,
                "id": 16
            }
        ],
        "name": "Shelter",
        "enabled": true,
        "id": 3
    },
    {
        "order": 4,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Alligator",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Alligator.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Alligator.svg",
                "defaultColor": "#9ECC3B",
                "name": "Alligator",
                "enabled": true,
                "id": 9
            },
            {
                "description": "Antelope",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Antelope.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Antelope.svg",
                "defaultColor": "#9ECC3B",
                "name": "Antelope",
                "enabled": true,
                "id": 10
            },
            {
                "description": "Bear (Black)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bear_(Black).png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bear%20%28Black%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Bear (Black)",
                "enabled": true,
                "id": 12
            },
            {
                "description": "Bear (Grizzly)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bear_(Grizzly).png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bear%20%28Grizzly%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Bear (Grizzly)",
                "enabled": true,
                "id": 13
            },
            {
                "description": "Bison",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bison.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bison.svg",
                "defaultColor": "#9ECC3B",
                "name": "Bison",
                "enabled": true,
                "id": 14
            },
            {
                "description": "Caribou",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Caribou.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Caribou.svg",
                "defaultColor": "#9ECC3B",
                "name": "Caribou",
                "enabled": true,
                "id": 17
            },
            {
                "description": "Coyote",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Coyote.png",
                "order": 2,
                "created": "2018-10-22T20:08:46",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Coyote.svg",
                "defaultColor": "#9ECC3B",
                "name": "Coyote",
                "enabled": true,
                "id": 86
            },
            {
                "description": "Dove",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Dove.png",
                "order": 2,
                "created": "2018-10-22T20:08:46",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dove.svg",
                "defaultColor": "#9ECC3B",
                "name": "Dove",
                "enabled": true,
                "id": 85
            },
            {
                "description": "Duck",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Duck.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Duck.svg",
                "defaultColor": "#9ECC3B",
                "name": "Duck",
                "enabled": true,
                "id": 21
            },
            {
                "description": "Elk",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Elk.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Elk%20%28Bull%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Elk (Bull)",
                "enabled": true,
                "id": 22
            },
            {
                "description": "Goose",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Goose.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Goose.svg",
                "defaultColor": "#9ECC3B",
                "name": "Goose",
                "enabled": true,
                "id": 67
            },
            {
                "description": "Havelina",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Havelina.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Javelina.svg",
                "defaultColor": "#9ECC3B",
                "name": "Javelina",
                "enabled": true,
                "id": 26
            },
            {
                "description": "Moose",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Moose.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Moose%20%28Bull%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Moose (Bull)",
                "enabled": true,
                "id": 29
            },
            {
                "description": "Mountain Goat",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Mountain_Goat.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mountain%20Goat.svg",
                "defaultColor": "#9ECC3B",
                "name": "Mountain Goat",
                "enabled": true,
                "id": 30
            },
            {
                "description": "Mountain Lion",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Mountain_Lion.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mountain%20Lion.svg",
                "defaultColor": "#9ECC3B",
                "name": "Mountain Lion",
                "enabled": true,
                "id": 55
            },
            {
                "description": "Deer (Mule Deer)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_(Mule_Deer).png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mule%20Deer%20%28Buck%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Mule Deer (Buck)",
                "enabled": true,
                "id": 18
            },
            {
                "description": "Muskox",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Muskox.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Muskox.svg",
                "defaultColor": "#9ECC3B",
                "name": "Muskox",
                "enabled": true,
                "id": 31
            },
            {
                "description": "Pheasant",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Pheasant.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Pheasant.svg",
                "defaultColor": "#9ECC3B",
                "name": "Pheasant",
                "enabled": true,
                "id": 32
            },
            {
                "description": "Quail",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Quail.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Quail.svg",
                "defaultColor": "#9ECC3B",
                "name": "Quail",
                "enabled": true,
                "id": 33
            },
            {
                "description": "Sheep",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Sheep.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sheep%20%28Ram%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Sheep (Ram)",
                "enabled": true,
                "id": 35
            },
            {
                "description": "Wild Turkey",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wild_Turkey.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turkey%20%28Tom%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Turkey (Tom)",
                "enabled": true,
                "id": 42
            },
            {
                "description": "Deer (Whitetail)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_(Whitetail).png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Whitetail%20%28Buck%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Whitetail (Buck)",
                "enabled": true,
                "id": 19
            },
            {
                "description": "Wild Boar",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wild_Boar.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wild%20Boar.svg",
                "defaultColor": "#9ECC3B",
                "name": "Wild Boar",
                "enabled": true,
                "id": 41
            },
            {
                "description": "Wolf",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wolf.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 5,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wolf.svg",
                "defaultColor": "#9ECC3B",
                "name": "Wolf",
                "enabled": true,
                "id": 43
            }
        ],
        "name": "Wildlife",
        "enabled": true,
        "id": 5
    },
    {
        "order": 5,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Blood",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Blood.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Blood.svg",
                "defaultColor": "#9ECC3B",
                "name": "Blood",
                "enabled": true,
                "id": 15
            },
            {
                "description": "Feeder",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_Feeder.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Feeder.svg",
                "defaultColor": "#9ECC3B",
                "name": "Feeder",
                "enabled": true,
                "id": 20
            },
            {
                "description": "Food Plot",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Food_Plot.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Food%20Plot.svg",
                "defaultColor": "#9ECC3B",
                "name": "Food Plot",
                "enabled": true,
                "id": 23
            },
            {
                "description": "Glassing Point",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Glassing_Point.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Glassing%20Point.svg",
                "defaultColor": "#9ECC3B",
                "name": "Glassing Point",
                "enabled": true,
                "id": 25
            },
            {
                "description": "Tracks",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Tracks.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Tracks.svg",
                "defaultColor": "#9ECC3B",
                "name": "Tracks",
                "enabled": true,
                "id": 36
            },
            {
                "description": "Trail Camera",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Trail_Camera.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trail%20Camera.svg",
                "defaultColor": "#9ECC3B",
                "name": "Trail Camera",
                "enabled": true,
                "id": 37
            },
            {
                "description": "Trap",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Trap.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trap%20%28Foot%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Trap (Foot)",
                "enabled": true,
                "id": 38
            },
            {
                "description": "Wallow",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wallow.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wallow.svg",
                "defaultColor": "#9ECC3B",
                "name": "Wallow",
                "enabled": true,
                "id": 54
            },
            {
                "description": "Water Source",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Water_Source.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 6,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Water%20Source.svg",
                "defaultColor": "#9ECC3B",
                "name": "Water Source",
                "enabled": true,
                "id": 40
            }
        ],
        "name": "Hunting",
        "enabled": true,
        "id": 6
    },
    {
        "order": 6,
        "created": "2022-09-01T17:55:36",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Stand (Blind)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/stand-blind.png",
                "order": 2,
                "created": "2020-09-01T20:29:23",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 3,
                "markerGroupId": 11,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Ground%20Blind%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Stand (Blind)",
                "enabled": true,
                "id": 88
            },
            {
                "description": "Stand (Elevated)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/stand-elevated.png",
                "order": 2,
                "created": "2018-10-22T20:08:46",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 3,
                "markerGroupId": 11,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Box%20Blind%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Stand (Elevated)",
                "enabled": true,
                "id": 87
            },
            {
                "description": "Stand (Ladder)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Ladder_Stand.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 3,
                "markerGroupId": 11,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Ladder%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Stand (Ladder)",
                "enabled": true,
                "id": 28
            },
            {
                "description": "Stand (Tree)",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Tree_Stand.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 3,
                "markerGroupId": 11,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Tree%20Stand%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Stand (Tree)",
                "enabled": true,
                "id": 39
            }
        ],
        "name": "Hunt Stands",
        "enabled": true,
        "id": 11
    },
    {
        "order": 7,
        "created": "2022-09-01T17:55:36",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Shed",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Shed.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 12,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Shed%20%28Deer%29.svg",
                "defaultColor": "#9ECC3B",
                "name": "Shed (Deer)",
                "enabled": true,
                "id": 34
            }
        ],
        "name": "Shed Hunting",
        "enabled": true,
        "id": 12
    },
    {
        "order": 8,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Fish",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Fish.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 7,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Fish.svg",
                "defaultColor": "#00E5FF",
                "name": "Fish",
                "enabled": true,
                "id": 69
            },
            {
                "description": "Hazard",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Hazard.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 7,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Hazard.svg",
                "defaultColor": "#00E5FF",
                "name": "Hazard",
                "enabled": true,
                "id": 27
            },
            {
                "description": "Log",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Log.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 7,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Log.svg",
                "defaultColor": "#00E5FF",
                "name": "Log",
                "enabled": true,
                "id": 70
            },
            {
                "description": "School",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/School.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 7,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/School.svg",
                "defaultColor": "#00E5FF",
                "name": "School",
                "enabled": true,
                "id": 71
            },
            {
                "description": "Stump",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Stump.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 7,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stump.svg",
                "defaultColor": "#00E5FF",
                "name": "Stump",
                "enabled": true,
                "id": 72
            }
        ],
        "name": "Fishing",
        "enabled": true,
        "id": 7
    },
    {
        "order": 9,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Cairn",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cairn.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cairn.svg",
                "defaultColor": "#9ECC3B",
                "name": "Cairn",
                "enabled": true,
                "id": 45
            },
            {
                "description": "Checkpoint",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Checkpoint.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Checkpoint.svg",
                "defaultColor": "#9ECC3B",
                "name": "Checkpoint",
                "enabled": true,
                "id": 47
            },
            {
                "description": "Geocache",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Geocache.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Geocache.svg",
                "defaultColor": "#9ECC3B",
                "name": "Geocache",
                "enabled": true,
                "id": 48
            },
            {
                "description": "Parking",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Parking.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Parking.svg",
                "defaultColor": "#9ECC3B",
                "name": "Parking",
                "enabled": true,
                "id": 49
            },
            {
                "description": "Summit",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Summit.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Summit.svg",
                "defaultColor": "#9ECC3B",
                "name": "Summit",
                "enabled": true,
                "id": 51
            },
            {
                "description": "TrailHead",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/TrailHead.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trailhead.svg",
                "defaultColor": "#9ECC3B",
                "name": "TrailHead",
                "enabled": true,
                "id": 52
            },
            {
                "description": "Waterfall",
                "activityId": 2,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Waterfall.png",
                "order": 2,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 4,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Waterfall.svg",
                "defaultColor": "#9ECC3B",
                "name": "Waterfall",
                "enabled": true,
                "id": 53
            }
        ],
        "name": "Hiking",
        "enabled": true,
        "id": 4
    },
    {
        "order": 10,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "version": 1,
        "markerType": [
            {
                "description": "Orange",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Orange.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "ff6800",
                "name": "Orange",
                "enabled": true,
                "id": 83
            },
            {
                "description": "Dark Blue Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Dark_Blue.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "00ffff",
                "name": "Dark Blue",
                "enabled": true,
                "id": 3
            },
            {
                "description": "Green Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Green.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "589500",
                "name": "Green",
                "enabled": true,
                "id": 4
            },
            {
                "description": "Grey Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Grey.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "b6b6b6",
                "name": "Grey",
                "enabled": true,
                "id": 5
            },
            {
                "description": "Light Blue Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Light_Blue.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "0000ff",
                "name": "Light Blue",
                "enabled": true,
                "id": 2
            },
            {
                "description": "Pink Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Pink.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "ff00ff",
                "name": "Pink",
                "enabled": true,
                "id": 6
            },
            {
                "description": "Red Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Red.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "ff0000",
                "name": "Red",
                "enabled": true,
                "id": 7
            },
            {
                "description": "Yellow Icon",
                "activityId": 255,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Yellow.png",
                "order": 3,
                "created": "2018-04-30T00:00:00",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 10,
                "vectorIconUrl": "",
                "version": 1,
                "defaultColor": "ffff00",
                "name": "Yellow",
                "enabled": true,
                "id": 8
            }
        ],
        "name": "Colored",
        "enabled": true,
        "id": 10
    },
    {
        "order": 10,
        "created": "2018-06-29T20:49:44.2713",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Corner Pin",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Corner_Pin.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 9,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Corner%20Pin.svg",
                "defaultColor": "#9ECC3B",
                "name": "Corner Pin",
                "enabled": true,
                "id": 81
            },
            {
                "description": "Fence",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Fence.png",
                "order": 2,
                "created": "2018-06-29T20:49:59.7532",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 9,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Fenceline.svg",
                "defaultColor": "#9ECC3B",
                "name": "Fence",
                "enabled": true,
                "id": 82
            },
            {
                "description": "Gate",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Gate.png",
                "order": 2,
                "created": "2018-04-18T06:26:20.3407",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 9,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Gate.svg",
                "defaultColor": "#9ECC3B",
                "name": "Gate",
                "enabled": true,
                "id": 24
            }
        ],
        "name": "Property",
        "enabled": true,
        "id": 9
    },
    {
        "order": 11,
        "created": "2022-09-01T17:55:36",
        "updated": "2022-09-09T23:24:48",
        "markerType": [
            {
                "description": "Leica LRF",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/leica.png",
                "order": 3,
                "created": "2021-12-30T18:05:55",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 13,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Leica.svg",
                "defaultColor": "#F0F0F0",
                "name": "Leica LRF",
                "enabled": true,
                "id": 90
            },
            {
                "description": "SIG LRF",
                "activityId": 1,
                "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/sig.png",
                "order": 3,
                "created": "2021-08-02T17:06:36",
                "updated": "2022-09-09T23:24:49",
                "usageFlag": 1,
                "markerGroupId": 13,
                "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sig.svg",
                "defaultColor": "#FFD533",
                "name": "SIG LRF",
                "enabled": true,
                "id": 89
            }
        ],
        "name": "Partners",
        "enabled": true,
        "id": 13
    }
]





export const icons = [
    {
        "description": "Antelope",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Antelope.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Antelope.svg",
        "defaultColor": "#9ECC3B",
        "name": "Antelope",
        "enabled": true,
        "id": 10
    },
    {
        "description": "Arrow",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Arrow.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Arrow",
        "enabled": true,
        "id": 93
    },
    {
        "description": "ATV",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/ATV.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/ATV.svg",
        "defaultColor": "#9ECC3B",
        "name": "ATV",
        "enabled": true,
        "id": 11
    },
    {
        "description": "Axis Deer",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Axis%20Deer.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Axis Deer",
        "enabled": true,
        "id": 94
    },
]


export const ArrayData = [
    {
        "description": "Location",
        "activityId": 255,
        "order": 1,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 1,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Location",
        "enabled": true,
        "id": 134
    },
    {
        "description": "Access point",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Access%20Point.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Access point",
        "enabled": true,
        "id": 91
    },
    {
        "description": "Alligator",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Alligator.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Alligator.svg",
        "defaultColor": "#9ECC3B",
        "name": "Alligator",
        "enabled": true,
        "id": 9
    },
    {
        "description": "Anchored",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Anchored.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Anchored",
        "enabled": true,
        "id": 92
    },
    {
        "description": "Antelope",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Antelope.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Antelope.svg",
        "defaultColor": "#9ECC3B",
        "name": "Antelope",
        "enabled": true,
        "id": 10
    },
    {
        "description": "Arrow",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Arrow.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Arrow",
        "enabled": true,
        "id": 93
    },
    {
        "description": "ATV",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/ATV.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/ATV.svg",
        "defaultColor": "#9ECC3B",
        "name": "ATV",
        "enabled": true,
        "id": 11
    },
    {
        "description": "Axis Deer",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Axis%20Deer.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Axis Deer",
        "enabled": true,
        "id": 94
    },
    {
        "description": "Bait",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bait.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Bait",
        "enabled": true,
        "id": 95
    },
    {
        "description": "Barbary Sheep",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Barbary%20Sheep.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Barbary Sheep",
        "enabled": true,
        "id": 96
    },
    {
        "description": "Bass",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bass.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Bass",
        "enabled": true,
        "id": 97
    },
    {
        "description": "Bear (Alaskan Brown)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bear%20%28Alaskan%20Brown%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Bear (Alaskan Brown)",
        "enabled": true,
        "id": 98
    },
    {
        "description": "Bear (Black)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bear_(Black).png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bear%20%28Black%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Bear (Black)",
        "enabled": true,
        "id": 12
    },
    {
        "description": "Bear (Grizzly)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bear_(Grizzly).png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bear%20%28Grizzly%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Bear (Grizzly)",
        "enabled": true,
        "id": 13
    },
    {
        "description": "Bedding Area",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bedding%20Area.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Bedding Area",
        "enabled": true,
        "id": 99
    },
    {
        "description": "Bike",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bike.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bike.svg",
        "defaultColor": "#9ECC3B",
        "name": "Bike",
        "enabled": true,
        "id": 44
    },
    {
        "description": "Bison",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Bison.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bison.svg",
        "defaultColor": "#9ECC3B",
        "name": "Bison",
        "enabled": true,
        "id": 14
    },
    {
        "description": "Black Buck",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Black%20Buck.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Black Buck",
        "enabled": true,
        "id": 100
    },
    {
        "description": "Blacktail Deer (Buck)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Blacktail%20Deer%20%28Buck%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Blacktail Deer (Buck)",
        "enabled": true,
        "id": 101
    },
    {
        "description": "Blacktail Deer (Doe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Blacktail%20Deer%20%28Doe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Blacktail Deer (Doe)",
        "enabled": true,
        "id": 102
    },
    {
        "description": "Blood",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Blood.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Blood.svg",
        "defaultColor": "#9ECC3B",
        "name": "Blood",
        "enabled": true,
        "id": 15
    },
    {
        "description": "Boat",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Boat.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Boat.svg",
        "defaultColor": "#9ECC3B",
        "name": "Boat",
        "enabled": true,
        "id": 56
    },
    {
        "description": "Boat Ramp",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Boat%20Ramp.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Boat Ramp",
        "enabled": true,
        "id": 103
    },
    {
        "description": "Bobcat",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Bobcat.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Bobcat",
        "enabled": true,
        "id": 104
    },
    {
        "description": "Boots",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Boots.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Boots",
        "enabled": true,
        "id": 105
    },
    {
        "description": "Cabin",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cabin.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cabin.svg",
        "defaultColor": "#9ECC3B",
        "name": "Cabin",
        "enabled": true,
        "id": 62
    },
    {
        "description": "Cairn",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cairn.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cairn.svg",
        "defaultColor": "#9ECC3B",
        "name": "Cairn",
        "enabled": true,
        "id": 45
    },
    {
        "description": "Camp",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Camp.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Camp",
        "enabled": true,
        "id": 106
    },
    {
        "description": "Canoe",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Canoe.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Canoe",
        "enabled": true,
        "id": 107
    },
    {
        "description": "Canyon",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Canyon.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Canyon",
        "enabled": true,
        "id": 108
    },
    {
        "description": "Car",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/car.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Car.svg",
        "defaultColor": "#9ECC3B",
        "name": "Car",
        "enabled": true,
        "id": 57
    },
    {
        "description": "Caribou",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Caribou.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Caribou.svg",
        "defaultColor": "#9ECC3B",
        "name": "Caribou",
        "enabled": true,
        "id": 17
    },
    {
        "description": "Catch",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Catch.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Catch",
        "enabled": true,
        "id": 109
    },
    {
        "description": "Cave",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Cave.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cave.svg",
        "defaultColor": "#9ECC3B",
        "name": "Cave",
        "enabled": true,
        "id": 46
    },
    {
        "description": "Checkpoint",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Checkpoint.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Checkpoint.svg",
        "defaultColor": "#9ECC3B",
        "name": "Checkpoint",
        "enabled": true,
        "id": 47
    },
    {
        "description": "Chukar",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Chukar.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Chukar",
        "enabled": true,
        "id": 110
    },
    {
        "description": "Corner Pin",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Corner_Pin.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Corner%20Pin.svg",
        "defaultColor": "#9ECC3B",
        "name": "Corner Pin",
        "enabled": true,
        "id": 81
    },
    {
        "description": "Coues Deer (Buck)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Coues%20Deer%20%28Buck%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Coues Deer (Buck)",
        "enabled": true,
        "id": 111
    },
    {
        "description": "Coues Deer (Doe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Coues%20Deer%20%28Doe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Coues Deer (Doe)",
        "enabled": true,
        "id": 112
    },
    {
        "description": "Coyote",
        "activityId": 255,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Coyote.png",
        "order": 2,
        "created": "2018-10-22T20:08:46",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Coyote.svg",
        "defaultColor": "#9ECC3B",
        "name": "Coyote",
        "enabled": true,
        "id": 86
    },
    {
        "description": "Creek",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Creek.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Creek",
        "enabled": true,
        "id": 113
    },
    {
        "description": "Crossing",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Crossing.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Crossing",
        "enabled": true,
        "id": 114
    },
    {
        "description": "Dead Head",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 12,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dead%20Head.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Dead Head",
        "enabled": true,
        "id": 115
    },
    {
        "description": "Default Icon",
        "activityId": 255,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Default.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 1,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg",
        "defaultColor": "#9ECC3B",
        "name": "Default",
        "enabled": true,
        "id": 1
    },
    {
        "description": "Den",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Den.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Den",
        "enabled": true,
        "id": 116
    },
    {
        "description": "Dog On Point",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dog%20On%20Point.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Dog On Point",
        "enabled": true,
        "id": 117
    },
    {
        "description": "Dove",
        "activityId": 255,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Dove.png",
        "order": 2,
        "created": "2018-10-22T20:08:46",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dove.svg",
        "defaultColor": "#9ECC3B",
        "name": "Dove",
        "enabled": true,
        "id": 85
    },
    {
        "description": "Draw",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Draw.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Draw",
        "enabled": true,
        "id": 118
    },
    {
        "description": "Drop Off",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Drop%20Off.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Drop Off",
        "enabled": true,
        "id": 119
    },
    {
        "description": "Duck",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Duck.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Duck.svg",
        "defaultColor": "#9ECC3B",
        "name": "Duck",
        "enabled": true,
        "id": 21
    },
    {
        "description": "Easement",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Easement.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Easement",
        "enabled": true,
        "id": 120
    },
    {
        "description": "Elk",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Elk.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Elk%20%28Bull%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Elk (Bull)",
        "enabled": true,
        "id": 22
    },
    {
        "description": "Elk (Cow)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Elk%20%28Cow%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Elk (Cow)",
        "enabled": true,
        "id": 121
    },
    {
        "description": "Fallow Deer",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Fallow%20Deer.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Fallow Deer",
        "enabled": true,
        "id": 122
    },
    {
        "description": "Feeder",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_Feeder.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Feeder.svg",
        "defaultColor": "#9ECC3B",
        "name": "Feeder",
        "enabled": true,
        "id": 20
    },
    {
        "description": "Feeding Area",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Feeding%20Area.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Feeding Area",
        "enabled": true,
        "id": 123
    },
    {
        "description": "Fence",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Fence.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Fenceline.svg",
        "defaultColor": "#9ECC3B",
        "name": "Fence",
        "enabled": true,
        "id": 82
    },
    {
        "description": "Feral Hog",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Feral%20Hog.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Feral Hog",
        "enabled": true,
        "id": 124
    },
    {
        "description": "Fish",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Fish.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Fish.svg",
        "defaultColor": "#00E5FF",
        "name": "Fish",
        "enabled": true,
        "id": 69
    },
    {
        "description": "Flats",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Flats.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Flats",
        "enabled": true,
        "id": 125
    },
    {
        "description": "Food Plot",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Food_Plot.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Food%20Plot.svg",
        "defaultColor": "#9ECC3B",
        "name": "Food Plot",
        "enabled": true,
        "id": 23
    },
    {
        "description": "Food Source",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Food%20Source.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Food Source",
        "enabled": true,
        "id": 126
    },
    {
        "description": "Funnel",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Funnel.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Funnel",
        "enabled": true,
        "id": 127
    },
    {
        "description": "Game Trail",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Game%20Trail.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Game Trail",
        "enabled": true,
        "id": 128
    },
    {
        "description": "Gate",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Gate.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Gate.svg",
        "defaultColor": "#9ECC3B",
        "name": "Gate",
        "enabled": true,
        "id": 24
    },
    {
        "description": "Geocache",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Geocache.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Geocache.svg",
        "defaultColor": "#9ECC3B",
        "name": "Geocache",
        "enabled": true,
        "id": 48
    },
    {
        "description": "Glassing Point",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Glassing_Point.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Glassing%20Point.svg",
        "defaultColor": "#9ECC3B",
        "name": "Glassing Point",
        "enabled": true,
        "id": 25
    },
    {
        "description": "Goose",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Goose.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Goose.svg",
        "defaultColor": "#9ECC3B",
        "name": "Goose",
        "enabled": true,
        "id": 67
    },
    {
        "description": "Grouse",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Grouse.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Grouse",
        "enabled": true,
        "id": 129
    },
    {
        "description": "Guzzler",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Guzzler.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Guzzler",
        "enabled": true,
        "id": 130
    },
    {
        "description": "Hazard",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Hazard.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Hazard.svg",
        "defaultColor": "#00E5FF",
        "name": "Hazard",
        "enabled": true,
        "id": 27
    },
    {
        "description": "Hole",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Hole.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Hole",
        "enabled": true,
        "id": 131
    },
    {
        "description": "Home",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Home.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Home.svg",
        "defaultColor": "#9ECC3B",
        "name": "Home",
        "enabled": true,
        "id": 63
    },
    {
        "description": "Horse",
        "activityId": 255,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Horse.png",
        "order": 2,
        "created": "2018-10-22T20:08:46",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Horse.svg",
        "defaultColor": "#9ECC3B",
        "name": "Horse",
        "enabled": true,
        "id": 84
    },
    {
        "description": "Ibex",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Ibex.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Ibex",
        "enabled": true,
        "id": 132
    },
    {
        "description": "Havelina",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Havelina.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Javelina.svg",
        "defaultColor": "#9ECC3B",
        "name": "Javelina",
        "enabled": true,
        "id": 26
    },
    {
        "description": "Kayak",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/kayak.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Kayak.svg",
        "defaultColor": "#9ECC3B",
        "name": "Kayak",
        "enabled": true,
        "id": 58
    },
    {
        "description": "Kudamundai",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Kudamundai.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Kudamundai",
        "enabled": true,
        "id": 133
    },
    {
        "description": "Lodge",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Shelter.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Cabin.svg",
        "defaultColor": "589500",
        "name": "Lodge",
        "enabled": true,
        "id": 50
    },
    {
        "description": "Log",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Log.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Log.svg",
        "defaultColor": "#00E5FF",
        "name": "Log",
        "enabled": true,
        "id": 70
    },
    {
        "description": "Meat",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Meat.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Meat",
        "enabled": true,
        "id": 135
    },
    {
        "description": "Mineral Lick",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mineral%20Lick.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Mineral Lick",
        "enabled": true,
        "id": 136
    },
    {
        "description": "Moose",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Moose.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Moose%20%28Bull%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Moose (Bull)",
        "enabled": true,
        "id": 29
    },
    {
        "description": "Moose (Cow)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Moose%20%28Cow%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Moose (Cow)",
        "enabled": true,
        "id": 137
    },
    {
        "description": "Motorcycle",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Motorcycle.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Dirt%20Bike.svg",
        "defaultColor": "#9ECC3B",
        "name": "Motorcycle",
        "enabled": true,
        "id": 59
    },
    {
        "description": "Mountain Goat",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Mountain_Goat.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mountain%20Goat.svg",
        "defaultColor": "#9ECC3B",
        "name": "Mountain Goat",
        "enabled": true,
        "id": 30
    },
    {
        "description": "Mountain Lion",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Mountain_Lion.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mountain%20Lion.svg",
        "defaultColor": "#9ECC3B",
        "name": "Mountain Lion",
        "enabled": true,
        "id": 55
    },
    {
        "description": "Mule",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mule.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Mule",
        "enabled": true,
        "id": 138
    },
    {
        "description": "Deer (Mule Deer)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_(Mule_Deer).png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mule%20Deer%20%28Buck%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Mule Deer (Buck)",
        "enabled": true,
        "id": 18
    },
    {
        "description": "Mule Deer (Doe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Mule%20Deer%20%28Doe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Mule Deer (Doe)",
        "enabled": true,
        "id": 139
    },
    {
        "description": "Muskox",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Muskox.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Muskox.svg",
        "defaultColor": "#9ECC3B",
        "name": "Muskox",
        "enabled": true,
        "id": 31
    },
    {
        "description": "Nilgai",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Nilgai.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Nilgai",
        "enabled": true,
        "id": 140
    },
    {
        "description": "Oryx",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Oryx.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Oryx",
        "enabled": true,
        "id": 141
    },
    {
        "description": "Pack",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Pack.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Pack",
        "enabled": true,
        "id": 142
    },
    {
        "description": "Pack Goat",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Pack%20Goat.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Pack Goat",
        "enabled": true,
        "id": 143
    },
    {
        "description": "Packframe",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Packframe.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Packframe",
        "enabled": true,
        "id": 144
    },
    {
        "description": "Parking",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Parking.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Parking.svg",
        "defaultColor": "#9ECC3B",
        "name": "Parking",
        "enabled": true,
        "id": 49
    },
    {
        "description": "Pheasant",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Pheasant.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Pheasant.svg",
        "defaultColor": "#9ECC3B",
        "name": "Pheasant",
        "enabled": true,
        "id": 32
    },
    {
        "description": "Pinch Point",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Pinch%20Point.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Pinch Point",
        "enabled": true,
        "id": 145
    },
    {
        "description": "Possum",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Possum.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Possum",
        "enabled": true,
        "id": 146
    },
    {
        "description": "Prairie Dog Colony",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Prairie%20Dog%20Colony.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Prairie Dog Colony",
        "enabled": true,
        "id": 147
    },
    {
        "description": "Quail",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Quail.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Quail.svg",
        "defaultColor": "#9ECC3B",
        "name": "Quail",
        "enabled": true,
        "id": 33
    },
    {
        "description": "Racoon",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Racoon.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Racoon",
        "enabled": true,
        "id": 148
    },
    {
        "description": "Rapids",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Rapids.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Rapids",
        "enabled": true,
        "id": 149
    },
    {
        "description": "Ridge",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Ridge.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Ridge",
        "enabled": true,
        "id": 150
    },
    {
        "description": "Rifle",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Rifle.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Rifle",
        "enabled": true,
        "id": 151
    },
    {
        "description": "Riprap",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Riprap.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Riprap",
        "enabled": true,
        "id": 152
    },
    {
        "description": "Rock",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Rock.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Rock",
        "enabled": true,
        "id": 153
    },
    {
        "description": "Rub",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Rub.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Rub",
        "enabled": true,
        "id": 154
    },
    {
        "description": "RV",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/RV.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/RV.svg",
        "defaultColor": "#9ECC3B",
        "name": "RV",
        "enabled": true,
        "id": 65
    },
    {
        "description": "Saddle",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Saddle.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Saddle",
        "enabled": true,
        "id": 155
    },
    {
        "description": "Scat",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Scat.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Scat",
        "enabled": true,
        "id": 156
    },
    {
        "description": "School",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/School.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/School.svg",
        "defaultColor": "#00E5FF",
        "name": "School",
        "enabled": true,
        "id": 71
    },
    {
        "description": "Scrape",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Scrape.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Scrape",
        "enabled": true,
        "id": 157
    },
    {
        "description": "Shed",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Shed.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 12,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Shed%20%28Deer%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Shed (Deer)",
        "enabled": true,
        "id": 34
    },
    {
        "description": "Shed (Elk)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 12,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Shed%20%28Elk%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Shed (Elk)",
        "enabled": true,
        "id": 158
    },
    {
        "description": "Shed (Moose)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 12,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Shed%20%28Moose%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Shed (Moose)",
        "enabled": true,
        "id": 159
    },
    {
        "description": "Sheep (Ewe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sheep%20%28Ewe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Sheep (Ewe)",
        "enabled": true,
        "id": 160
    },
    {
        "description": "Sheep",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Sheep.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sheep%20%28Ram%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Sheep (Ram)",
        "enabled": true,
        "id": 35
    },
    {
        "description": "Shot",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Shot.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Shot",
        "enabled": true,
        "id": 161
    },
    {
        "description": "Side by Side",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Side%20by%20Side.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Side by Side",
        "enabled": true,
        "id": 162
    },
    {
        "description": "Sitka Deer (Buck)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sitka%20Deer%20%28Buck%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Sitka Deer (Buck)",
        "enabled": true,
        "id": 163
    },
    {
        "description": "Sitka Deer (Doe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sitka%20Deer%20%28Doe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Sitka Deer (Doe)",
        "enabled": true,
        "id": 164
    },
    {
        "description": "Snag",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Snag.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Snag",
        "enabled": true,
        "id": 165
    },
    {
        "description": "Snowmobile",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Snowmobile.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Snowmobile.svg",
        "defaultColor": "#9ECC3B",
        "name": "Snowmobile",
        "enabled": true,
        "id": 60
    },
    {
        "description": "Spawning Area",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Spawning%20Area.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Spawning Area",
        "enabled": true,
        "id": 166
    },
    {
        "description": "Spawning Bed",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Spawning%20Bed.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Spawning Bed",
        "enabled": true,
        "id": 167
    },
    {
        "description": "Spike Camp",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Spike%20Camp.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Spike Camp",
        "enabled": true,
        "id": 168
    },
    {
        "description": "Squirrel",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Squirrel.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Squirrel",
        "enabled": true,
        "id": 169
    },
    {
        "description": "Stand (Blind)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/stand-blind.png",
        "order": 2,
        "created": "2020-09-01T20:29:23",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 3,
        "markerGroupId": 11,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Ground%20Blind%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Stand (Blind)",
        "enabled": true,
        "id": 88
    },
    {
        "description": "Stand (Duck Blind)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 3,
        "markerGroupId": 11,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Duck%20Blind%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Stand (Duck Blind)",
        "enabled": true,
        "id": 170
    },
    {
        "description": "Stand (Elevated)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/stand-elevated.png",
        "order": 2,
        "created": "2018-10-22T20:08:46",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 3,
        "markerGroupId": 11,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Box%20Blind%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Stand (Elevated)",
        "enabled": true,
        "id": 87
    },
    {
        "description": "Stand (Ladder)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Ladder_Stand.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 3,
        "markerGroupId": 11,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Ladder%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Stand (Ladder)",
        "enabled": true,
        "id": 28
    },
    {
        "description": "Stand (Tree)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Tree_Stand.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 3,
        "markerGroupId": 11,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stand%20%28Tree%20Stand%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Stand (Tree)",
        "enabled": true,
        "id": 39
    },
    {
        "description": "Stream",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stream.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Stream",
        "enabled": true,
        "id": 171
    },
    {
        "description": "Structure",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Structure.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Structure",
        "enabled": true,
        "id": 172
    },
    {
        "description": "Stump",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Stump.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Stump.svg",
        "defaultColor": "#00E5FF",
        "name": "Stump",
        "enabled": true,
        "id": 72
    },
    {
        "description": "Summit",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Summit.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Summit.svg",
        "defaultColor": "#9ECC3B",
        "name": "Summit",
        "enabled": true,
        "id": 51
    },
    {
        "description": "Tent",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Camp.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 3,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Tent.svg",
        "defaultColor": "#9ECC3B",
        "name": "Tent",
        "enabled": true,
        "id": 16
    },
    {
        "description": "Tracks",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Tracks.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Tracks.svg",
        "defaultColor": "#9ECC3B",
        "name": "Tracks",
        "enabled": true,
        "id": 36
    },
    {
        "description": "Trail",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trail.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Trail",
        "enabled": true,
        "id": 173
    },
    {
        "description": "Trail Camera",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Trail_Camera.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trail%20Camera.svg",
        "defaultColor": "#9ECC3B",
        "name": "Trail Camera",
        "enabled": true,
        "id": 37
    },
    {
        "description": "TrailHead",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/TrailHead.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trailhead.svg",
        "defaultColor": "#9ECC3B",
        "name": "TrailHead",
        "enabled": true,
        "id": 52
    },
    {
        "description": "Trap (Conibear)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trap%20%28Conibear%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Trap (Conibear)",
        "enabled": true,
        "id": 174
    },
    {
        "description": "Trap",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Trap.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trap%20%28Foot%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Trap (Foot)",
        "enabled": true,
        "id": 38
    },
    {
        "description": "Trap (Live)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trap%20%28Live%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Trap (Live)",
        "enabled": true,
        "id": 175
    },
    {
        "description": "Trap (Snare)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trap%20%28Snare%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Trap (Snare)",
        "enabled": true,
        "id": 176
    },
    {
        "description": "Trout",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 7,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Trout.svg",
        "version": 2,
        "defaultColor": "#00E5FF",
        "name": "Trout",
        "enabled": true,
        "id": 177
    },
    {
        "description": "Truck",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Truck.png",
        "order": 2,
        "created": "2018-06-29T20:49:59.7532",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 2,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Truck.svg",
        "defaultColor": "#9ECC3B",
        "name": "Truck",
        "enabled": true,
        "id": 61
    },
    {
        "description": "Turkey (Hen)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turkey%20%28Hen%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Turkey (Hen)",
        "enabled": true,
        "id": 178
    },
    {
        "description": "Turkey (Jake)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turkey%20%28Jake%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Turkey (Jake)",
        "enabled": true,
        "id": 179
    },
    {
        "description": "Wild Turkey",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wild_Turkey.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turkey%20%28Tom%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Turkey (Tom)",
        "enabled": true,
        "id": 42
    },
    {
        "description": "Turkey Roost",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turkey%20Roost.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Turkey Roost",
        "enabled": true,
        "id": 180
    },
    {
        "description": "Turn Here",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 9,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Turn%20Here.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Turn Here",
        "enabled": true,
        "id": 181
    },
    {
        "description": "Wallow",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wallow.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wallow.svg",
        "defaultColor": "#9ECC3B",
        "name": "Wallow",
        "enabled": true,
        "id": 54
    },
    {
        "description": "Water Source",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Water_Source.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 6,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Water%20Source.svg",
        "defaultColor": "#9ECC3B",
        "name": "Water Source",
        "enabled": true,
        "id": 40
    },
    {
        "description": "Waterfall",
        "activityId": 2,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Waterfall.png",
        "order": 2,
        "created": "2018-04-30T00:00:00",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 4,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Waterfall.svg",
        "defaultColor": "#9ECC3B",
        "name": "Waterfall",
        "enabled": true,
        "id": 53
    },
    {
        "description": "Deer (Whitetail)",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Deer_(Whitetail).png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Whitetail%20%28Buck%29.svg",
        "defaultColor": "#9ECC3B",
        "name": "Whitetail (Buck)",
        "enabled": true,
        "id": 19
    },
    {
        "description": "Whitetail (Doe)",
        "activityId": 255,
        "order": 2,
        "created": "2022-09-01T17:55:38",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Whitetail%20%28Doe%29.svg",
        "version": 2,
        "defaultColor": "#9ECC3B",
        "name": "Whitetail (Doe)",
        "enabled": true,
        "id": 182
    },
    {
        "description": "Wild Boar",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wild_Boar.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wild%20Boar.svg",
        "defaultColor": "#9ECC3B",
        "name": "Wild Boar",
        "enabled": true,
        "id": 41
    },
    {
        "description": "Wolf",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/Wolf.png",
        "order": 2,
        "created": "2018-04-18T06:26:20.3407",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 5,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Wolf.svg",
        "defaultColor": "#9ECC3B",
        "name": "Wolf",
        "enabled": true,
        "id": 43
    },
    {
        "description": "Leica LRF",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/leica.png",
        "order": 3,
        "created": "2021-12-30T18:05:55",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 13,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Leica.svg",
        "defaultColor": "#F0F0F0",
        "name": "Leica LRF",
        "enabled": true,
        "id": 90
    },
    {
        "description": "SIG LRF",
        "activityId": 1,
        "iconUrl": "https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/sig.png",
        "order": 3,
        "created": "2021-08-02T17:06:36",
        "updated": "2023-11-01T18:10:31",
        "usageFlag": 1,
        "markerGroupId": 13,
        "vectorIconUrl": "https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Sig.svg",
        "defaultColor": "#FFD533",
        "name": "SIG LRF",
        "enabled": true,
        "id": 89
    }
]
